import React, { useRef, useState } from 'react'
import Scrollspy from 'react-scrollspy';
import { ToggleModeButton } from '../'
import { CasesRoundedIcon, CloseRoundedIcon, MenuRoundedIcon, navlinks } from '../../utils/constants'
import { Link } from 'react-scroll'
import './navbar.css'

const Navbar = ({theme}) => {
  const modalNavRef                             = useRef()
  const [toggleNav, setToggleNav]               = useState(false)

  const closeNavModal = e => {
    if(modalNavRef.current === e.target){
      setToggleNav(false)
    }
  }

  return (
    <>
      <nav className='navbar'>
        <div className='navbar-logo'><CasesRoundedIcon /></div>
        <div className='navbar-show-btn navbar-open-close' onClick={() => setToggleNav((prev) => !prev)}><MenuRoundedIcon /></div>

        <div className={toggleNav ? 'navbar-collapse navbar-show' : 'navbar-collapse'} ref={modalNavRef} onClick={closeNavModal}>
          <div className='navbar-collapse-inner'>
            <div className='navbar-center'>
              <div className='navbar-hide-btn navbar-open-close' onClick={() => setToggleNav((prev) => !prev)}><CloseRoundedIcon /></div>
              <Scrollspy items={navlinks.map((result) => result.name.toLowerCase())} currentClassName="active" offset={-70}>
                <ul>
                  {navlinks.map((result, index) => (
                    <li key={index}><Link to={result.name.toLowerCase()} spy={true} offset={-70} duration={500} className='anchor' onClick={() => setToggleNav((prev) => !prev)}>{result.name}</Link></li>
                  ))}
                </ul>
              </Scrollspy>
            </div>
            <ToggleModeButton theme={theme} />
          </div>
        </div>
      </nav>
    </>
  )
}

export default Navbar